import { render, staticRenderFns } from "./HowWorkItem.vue?vue&type=template&id=4133604c&scoped=true&"
import script from "./HowWorkItem.vue?vue&type=script&lang=js&"
export * from "./HowWorkItem.vue?vue&type=script&lang=js&"
import style0 from "./HowWorkItem.vue?vue&type=style&index=0&id=4133604c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4133604c",
  null
  
)

export default component.exports